export const clientTitles = {
  0: 'M',
  1: 'F',
  2: 'J',
  U: 'U'
};
